/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationPreferencesRequest } from '../models/NotificationPreferencesRequest';
import type { NotificationPreferencesView } from '../models/NotificationPreferencesView';
import type { UserUpdateRequest } from '../models/UserUpdateRequest';
import type { UserView } from '../models/UserView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * Get user profile
     * @returns UserView User profile data
     * @throws ApiError
     */
    public static getAppUserGet(): CancelablePromise<UserView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/user',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Update user profile
     * @param requestBody
     * @returns UserView User profile updated successfully
     * @throws ApiError
     */
    public static putAppUserUpdate(
        requestBody: UserUpdateRequest,
    ): CancelablePromise<UserView> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
            },
        });
    }
    /**
     * Delete user account
     * Permanently deletes user account and all related data (subscriptions, shops, devices, etc.). For parent users, also deletes all subusers.
     * @returns any User deleted successfully
     * @throws ApiError
     */
    public static deleteAppUserDelete(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v2/api/user',
            errors: {
                400: `Cannot delete subuser account (must be deleted by parent)`,
            },
        });
    }
    /**
     * Get user language
     * @returns any User language
     * @throws ApiError
     */
    public static getAppUserLanguageGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/user/language',
        });
    }
    /**
     * Update user language
     * @param requestBody
     * @returns any Language updated
     * @throws ApiError
     */
    public static putAppUserLanguageUpdate(
        requestBody: {
            language?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/user/language',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get user verify reminder
     * @returns any User verify reminder data
     * @throws ApiError
     */
    public static getAppUserVerifyReminderGet(): CancelablePromise<{
        lastVerifyReminderDate?: string | null;
        verifyReminderCounter?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/user/verify-reminder',
        });
    }
    /**
     * Update user verify reminder (increment counter)
     * @returns any Verify reminder updated
     * @throws ApiError
     */
    public static putAppUserVerifyReminderUpdate(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/user/verify-reminder',
        });
    }
    /**
     * Get user Freshdesk API key
     * Returns Freshdesk API key if user has purchased the plugin
     * @returns any Freshdesk API key
     * @throws ApiError
     */
    public static getAppUserFreshdeskApiKey(): CancelablePromise<{
        success?: boolean;
        data?: {
            apiKey?: string;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/user/freshdesk-api-key',
            errors: {
                404: `API key not found (user has not purchased)`,
            },
        });
    }
    /**
     * Get task notification preferences for the current user
     * @returns NotificationPreferencesView Resolved toggles (defaults applied server-side)
     * @throws ApiError
     */
    public static getAppUserNotificationPreferencesGet(): CancelablePromise<NotificationPreferencesView> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/user/notification-preferences',
        });
    }
    /**
     * Replace task notification preferences for the current user
     * @param requestBody
     * @returns NotificationPreferencesView Updated preferences
     * @throws ApiError
     */
    public static putAppUserNotificationPreferencesPut(
        requestBody: NotificationPreferencesRequest,
    ): CancelablePromise<NotificationPreferencesView> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v2/api/user/notification-preferences',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid body`,
            },
        });
    }
}
